import { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import { useStoreActions } from '../../../common/fake-uim/store';
import type { InitializeFieldPayload } from '../../../common/fake-uim/store/types';
import type { FieldState } from 'state/persisted/request-create/types';

type FieldStateWithRendererType = FieldState & {
    rendererType: string;
};

const hasRendererType = (field: FieldState): field is FieldStateWithRendererType => {
    // Indeed it is typed as any, replace with Object.hasOwn once available in help-center.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.prototype.hasOwnProperty.call(field, 'rendererType');
};

export const useInitializeFields = ({ fields }: { fields: FieldState[] }) => {
    di(useStoreActions);
    // TODO: Replace with real useStoreActions hook and InitializeFieldPayload once uim is ready on platfrom.
    const { initializeFields } = useStoreActions();

    useEffect(() => {
        // TODO: Check isFieldSupported in below map once uim is ready on platfrom.
        const fieldsToInitialize: InitializeFieldPayload[] = fields.map((field) => {
            return {
                field: {
                    fieldName: field.label,
                    fieldId: field.id,
                    // TODO: https://ecosystem-platform.atlassian.net/browse/UIM-2339 the description prop contains HTML.
                    // Provide a description with Wiki markup as separated prop that we can use e.g. descriptionRaw
                    description: field.description,
                    // TODO: https://ecosystem-platform.atlassian.net/browse/UIM-2338 - Add support for value init from different props
                    value: field.value,
                    isRequired: field.required ?? false,
                    isVisible: field.displayed,
                    isReadOnly: field.disabled ?? false,
                    // Remove 'as string' on isUiModificationsSupportEnabled, ditto_uim_-_jsm_support_main FF cleanup
                    fieldType: field.jiraFieldType as string,
                    // TODO: https://ecosystem-platform.atlassian.net/browse/UIM-2338 - Add support for allowedValues init from different props
                    // allowedValues: field.options,
                },
                metadata: { fieldRenderer: hasRendererType(field) ? field.rendererType : undefined },
            };
        });

        initializeFields(fieldsToInitialize);

        // No deps, intialize once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
